import MataMataBannerWithCTA from "@components/Blocks/Banners/MataMataBannerWithCTA";
import BHBasePage, { BHBasePageProps } from "@routes/BHBasePage";
import { type ProcessedArticleData } from "@transformer/useOSResponse";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

export type UGCEmptyListingProps = {
  sectionName: string;
  data: ProcessedArticleData[];
};

export default function UGCEmptyListing({
  sectionName,
  data,
}: UGCEmptyListingProps) {
  const campaignTitle = data[0].campaignReference?.title
    ? data[0].campaignReference.title
    : data[0].title;

  const basePageProps: BHBasePageProps = {
    uniqueSectionName: sectionName,
    hasLb1Ads: false,
    pageAdTargetValue: PageAdTargetingTypeEnum.LISTING,
  };

  return (
    <BHBasePage {...basePageProps}>
      <MataMataBannerWithCTA />
      <div className="text-lg font-primary">
        <div className="mb-sm font-bold">
          <a
            className="text-blue-300 hover:text-blue-700 hover:underline"
            href={`/${sectionName}`}
          >
            {sectionName}
          </a>
        </div>
        <div className="flex flex-col-reverse md:flex-row md:items-center justify-between lg:justify-start mb-xs">
          <div className="self-start w-12/12 lg:w-6/12 xl:w-7/12 text-blue-100 font-bold">
            {campaignTitle}
          </div>
        </div>
      </div>
    </BHBasePage>
  );
}
